package com.taager.tracking.event

@Suppress("UnnecessaryAbstractClass")
abstract class Screen(val name: String)
